import React from "react";
import { motion } from "framer-motion";
import { useSiteCopy } from "@/lib/useSiteCopy";
import { Sparkles, Sprout, Sun, HeartPulse } from "lucide-react";

const ICONS = [Sparkles, Sprout, Sun, HeartPulse];

const Approach = () => {
  // siteCopy = dictionary + Site Content overrides + the tenant record (lib/useSiteCopy.js).
  const siteCopy = useSiteCopy();
  const approach = siteCopy.approach;
  const hotStone = siteCopy.images.hotStone;
  return (
    <section id="approach" data-testid="approach-section" className="relative py-24 md:py-36 bg-eh-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="col-span-12 lg:col-span-5"
          >
            <div className="relative rounded-[2.5rem] overflow-hidden aspect-[4/5] vignette">
              <img src={hotStone} alt="Wellness" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -z-10 -top-10 -left-10 w-72 h-72 rounded-full bg-eh-sage/20 blur-3xl" />
          </motion.div>

          <div className="col-span-12 lg:col-span-7 lg:pl-8">
            <span className="eyebrow">{approach.eyebrow}</span>
            <h2 className="font-display text-5xl md:text-6xl text-eh-ink mt-4 leading-[1.05] whitespace-pre-line">
              {approach.title}
            </h2>
            <p className="mt-6 text-lg md:text-xl text-eh-muted leading-relaxed max-w-2xl">
              {approach.lead}
            </p>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {approach.pillars.map((p, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: i * 0.07 }}
                    data-testid={`approach-pillar-${i}`}
                    className="group p-7 rounded-3xl bg-white border border-eh-border-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-15px_rgba(44,53,49,0.18)]"
                  >
                    <div className="w-11 h-11 rounded-2xl bg-eh-sage/15 text-eh-sage-deep flex items-center justify-center mb-4 transition-colors group-hover:bg-eh-sage/25">
                      <Icon size={20} />
                    </div>
                    <div className="font-display text-2xl text-eh-ink leading-snug">{p.title}</div>
                    <div className="mt-2 text-eh-muted leading-relaxed">{p.body}</div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Approach;
